import MainTitle from '../common/MainTitle';
import ImageLink from '../../js/utils/ImageLink';

const SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3366 11.8247L14.5207 4.59998C14.4657 4.517 14.3726 4.4679 14.2735 4.4679H11.3398C11.1027 4.4679 10.9613 4.73206 11.0925 4.92934L15.6688 11.8264C15.7349 11.9255 15.7349 12.055 15.6688 12.1541L11.0917 19.0731C10.9613 19.2704 11.1027 19.5337 11.3398 19.5337H14.2743C14.3734 19.5337 14.4665 19.4838 14.5216 19.4008L19.3383 12.1541C19.4044 12.0542 19.4044 11.9246 19.3383 11.8247H19.3366Z"
      fill={color ?? "#F5B844"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.86744 4.46704H4.91253C4.67546 4.46704 4.53406 4.73121 4.6653 4.92848L9.26277 11.8238C9.32881 11.9238 9.32966 12.0533 9.26277 12.1532L4.66445 19.0714C4.53321 19.2687 4.67461 19.5329 4.91168 19.5329H7.86744C7.96735 19.5329 8.06048 19.4829 8.11552 19.3999L12.9103 12.1532C12.9763 12.0541 12.9763 11.9246 12.9103 11.8255L8.11552 4.59997C8.06048 4.517 7.96735 4.46704 7.86829 4.46704H7.86744Z"
      fill={color ?? "#F5B844"}
    />
  </svg>
);

export default function AccordionItems({
  type = 'dark',
  mainTitle,
  title1,
  title2,
  startText,
  startImage,
  centerImage,
  endText,
  endImage,
  index,
  toggleAccordionItems,
  accordionIndexOpen
}) {
  return (
    <div className={`accordion-item ${type === 'dark' ? 'dark' : 'light'}`}>
      <button
        type="button"
        className="button accordion-item__title-container"
        onClick={() => toggleAccordionItems(index)}>
        <p>{mainTitle}</p>
        {/* <span>{`0${index + 1}.`}</span> */}
        <span>
          <SVG color="#262452" />
        </span>
      </button>
      <div
        className="accordion-item__content-container"
        aria-expanded={accordionIndexOpen === index}>
        <MainTitle type={type === 'dark' ? 'light' : 'dark'} tag="h2" className="text--2xl">
          <span>{title1}</span>
          <span
            className={`decorated-line 
              ${type === 'dark' ? 'decorated-line--light ' : 'decorated-line--dark '}
              decorated-line--left`}>
            {title2}
          </span>
        </MainTitle>

        <div className="content-wrapper">
          <div className="content-image content-image--left">
            <p>{startText}</p>
            <div className="media media--start">
              <img src={ImageLink(startImage.url)} alt={startImage.alt} />
            </div>
          </div>

          <div className="media media--main">
            <img className="large-image" src={ImageLink(centerImage.url)} alt={centerImage.alt} />
          </div>

          <div className="content-image content-image--right reverse">
            <p>{endText}</p>
            <div className="media media--end">
              <img src={ImageLink(endImage.url)} alt={endImage.alt} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
